























































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { format } from 'quasar'
import store from 'src/assets/store'
import DeadlineTimer from 'components/DeadlineTimer.vue'
import ModalDialog from 'components/modals/Dialog.vue'
import { Item, ItemTypeTopic, Session, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    DeadlineTimer,
    ModalDialog
  }
})
export default class AttendeeSessionButtonClose extends Vue {
  pad = format.pad
  ItemTypeTopic = ItemTypeTopic
  timeprogress = 0

  @Prop()
  readonly topic!: Item

  @Prop()
  readonly session!: Session

  @Prop()
  readonly attendee!: SessionAttendee

  @Ref()
  readonly dialogClose!: ModalDialog

  @Ref()
  readonly dialogFinish!: ModalDialog

  get sessionTimeTotal () {
    if (this.topic.typeTopic === ItemTypeTopic.Quiz && this.attendee.startedAt && (this.session.data?.timer || this.session.stoppedAt)) {
      let timerTotal
      let stopTotal
      if (this.session.stoppedAt) {
        stopTotal = (new Date(this.session.stoppedAt).getTime() - new Date(this.attendee.startedAt).getTime()) / 1000
      }
      if (this.session.data?.timer) {
        timerTotal = this.session.data?.timer
      }
      if (timerTotal && stopTotal) {
        return Math.min(timerTotal, stopTotal)
      } else{
        return stopTotal || timerTotal
      }
    }
  }

  get sessionTimeLeft () {
    if (this.topic.typeTopic === ItemTypeTopic.Quiz && this.attendee.startedAt && (this.session.data?.timer || this.session.stoppedAt)) {
      let timerLeft
      let stopLeft
      if (this.session.stoppedAt) {
        stopLeft = (new Date(this.session.stoppedAt).getTime() - store.now().getTime()) / 1000
      }
      if (this.session.data?.timer) {
        timerLeft = this.session.data?.timer - (store.now().getTime() - (new Date(this.attendee.startedAt).getTime())) / 1000
      }
      if (timerLeft && stopLeft) {
        return Math.min(timerLeft, stopLeft)
      } else{
        return stopLeft || timerLeft
      }
    }
  }

  get sessionTimer () {
    if (this.sessionTimeTotal !== undefined && this.sessionTimeLeft !== undefined) {
      return {
        start: new Date(Date.now() - (this.sessionTimeTotal - this.sessionTimeLeft) * 1000),
        end: new Date(Date.now() + this.sessionTimeLeft * 1000)
      }
    } else {
      return {}
    }
  }

  timeover () {
    if (this.sessionTimer.start) {
      this.finish('right')
    }
  }

  finish (action: string) {
    this.dialogFinish && this.dialogFinish.hide()
    if (action === 'right') {
      this.$emit('finish')
      this.close()
    }
  }

  close () {
    this.dialogClose && this.dialogClose.hide()
    this.$emit('close')
  }
}
